import { get, post } from "../utils/request";

/**
 * 获取锦鲤知识列表
 * @param {*} vm
 * @param {*} cb
 */
export const getKnowledgeList = (vm, cb) => {
  let params = {
    pageNo: vm.current,
    pageSize: vm.display
  };
  vm.tipsData = [];
  vm.isloading = true;
  vm.nodata = false;
  post("/api/koiknowledge/koiKnowledgeList", params)
    .then(res => {
      vm.isloading = false;
      if (res.code === 200) {
        vm.tipsData = res.data.list || [];
        vm.tipsData = vm.tipsData.map(item => {
          item.imgUrl = vm.comImgUrl + item.imgUrl;
          return item;
        });
        vm.recData = res.data.top || {};
        if (JSON.stringify(vm.recData) != "{}") {
          vm.recData.imgUrl = vm.comImgUrl + vm.recData.imgUrl;
        }
        vm.total = res.data.total;
        vm.isShowRecommend = JSON.stringify(vm.recData) == "{}" ? false : true;
      }
      if (cb !== undefined) {
        cb();
      }
      vm.nodata = vm.tipsData.length == 0 ? true : false;
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.isloading = false;
      vm.nodata = vm.tipsData.length == 0 ? true : false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取锦鲤知识详情
 * @param {*} vm
 * @param {*} cb
 */
export const getKnowledgeDetail = (vm, cb) => {
  let params = {
    id: vm.detailId
  };
  post("/api/koiknowledge/koiKnowledgeById", params)
    .then(res => {
      if (res.code === 200) {
        vm.detail = res.data || {};
        vm.detail.imgUrl = vm.comImgUrl + vm.detail.imgUrl;
      }
      if (cb !== undefined) {
        cb();
      }
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};
